package org.hs_soft.runmynesto.data.api_datasource.options.cash_register_config

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.create_new_region.CreateNewRegionModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.CreateNewRegionReopisotry
import org.hs_soft.runmynesto.domain.util.ApiUtils

class CreateNewRegionRepositoryImpl (
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): CreateNewRegionReopisotry
{

    override suspend fun createNewRegion(
        departmentId: String,
        name: String,
    ): CreateNewRegionModel {
        val abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put(
                "query", """
                    mutation createRegion(${'$'}fields: RegionInputReq!) {
                      cashAssist {
                        createRegion(fields:${'$'}fields) {
                          ${ApiUtils.Field.id}
                          ${ApiUtils.Field.mod_ver}
                          ${ApiUtils.Field.name}
                          ${ApiUtils.Field.departmentId}
                          ${ApiUtils.Field.__typename}
                        }
                        ${ApiUtils.Field.__typename}
                      }
                    }
                """.trimIndent()
            )


            putJsonObject("variables") {
                putJsonObject("fields"){
                    put("name",name)
                    put("departmentId",departmentId)
                }
            }
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }


    }

}
